__turbopack_context__.v({
  "className": "dm_serif_display_d5377064-module__LmFn0W__className",
});
